import { render, staticRenderFns } from "./new_vendor_form.vue?vue&type=template&id=1c603b1f&lang=pug"
import script from "./new_vendor_form.vue?vue&type=script&lang=js"
export * from "./new_vendor_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports